import { Observable } from "rxjs";

export interface CustomAuthResponse {
    access_token: string;
    refresh_token: string;
    expires_in: number;
}

export enum LoginType {
  ENTRA_ID = 'entraid',
  OTP = 'otp',
  CUSTOM = 'custom',
  AZURE = 'azure'
}

export interface AuthResponse {
  accessToken: string;
  refreshToken?: string;
  expiresAt: number;
}

export interface AuthProvider {
  login(credentials?: any): Observable<any>;
  getToken(): Observable<string | null>;
  isLoggedIn(): Observable<boolean>;
  logout(): void;
}

export const AUTH_KEYS = {
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    EXPIRES_AT: 'expires_at',
    LOGIN_TYPE: 'login_type',
} as const;